import React from 'react'

import { Box, TableSortLabel, Skeleton } from '@mui/material'

import { SortDirection } from '../../types'

import TableCell from './TableCell'
import { TableHeadItem } from './types'

// ----------------------------------------------------------------------------

export const visuallyHidden = {
  border: 0,
  margin: -1,
  padding: 0,
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  position: 'absolute',
  whiteSpace: 'nowrap',
  clip: 'rect(0 0 0 0)',
}

// -----------------------------------------------------------------------------

type TableHeadCellPropTypes<T> = {
  isLoading: boolean
  data: TableHeadItem<T>
  order: SortDirection
  orderBy: string
  onRequestSort: (property: keyof T) => void
  size: 'xs' | 'sm' | 'md' | 'lg'
}

const TableHeadCell = <T,>({
  size,
  data,
  orderBy,
  order,
  onRequestSort,
  isLoading,
}: TableHeadCellPropTypes<T>) => {
  const { id, label, align, alignRight, disableSort } = data

  const alignment = align || (alignRight ? 'right' : 'left')

  const onSort = () => {
    onRequestSort(id)
  }

  const HeadLabel = (
    <TableSortLabel
      hideSortIcon
      active={disableSort ? false : orderBy === id}
      direction={orderBy === id ? order : 'asc'}
      {...(!disableSort && { onClick: onSort })}
    >
      {label}
      {orderBy === id ? (
        <Box sx={{ ...visuallyHidden }}>
          {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
        </Box>
      ) : null}
    </TableSortLabel>
  )

  return (
    <TableCell size={size} bold align={alignment} sortDirection={orderBy === id ? order : false}>
      {isLoading ? (
        <Box width={'100%'} display={'flex'} justifyContent={alignment}>
          <Skeleton>{HeadLabel}</Skeleton>
        </Box>
      ) : (
        HeadLabel
      )}
    </TableCell>
  )
}

export default TableHeadCell
